export const DOCUMENTPATH = "DOCUMENTPATH";
export const DOCUMENTADDED = "DOCUMENTADDED";
export const DOCUMENTDIALOGSTATUS = "DOCUMENTDIALOGSTATUS";
export const DOCUMENTLOADING = "DOCUMENTLOADING";
